import React, { useState, useEffect } from 'react';
import ModalDialog, { DialogContent, DialogButton, DialogFooter, DialogTitle } from '../AlmeDialog/ModalDialog';
import RadioGroup from 'syf-component-library/ui/patterns/RadioGroup';
import Radio from 'syf-component-library/ui/atoms/Radio';
import styled from 'styled-components';
import { focusMessageBox } from '../AlmeUtilities/dom-utils';
const StyledRadioGroup = styled(RadioGroup) `
 
    
    &>legend {
        margin-bottom: 20px;
        font-weight: bold;
    }
    &>div {
        padding: 5px 0px;
        margin: 0px;
        border-bottom: solid 1px #c8c8c8;
        background-color: #ffffff;
    }

    &>div:first-of-type {
        border-radius: 10px 10px 0 0;

    }
    &>div:last-child {
        border-radius: 0 0 10px 10px;
    }
    &>div > label > span {
        margin-right : 0px;
    }
    &>div >label > span > span > span {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%)
    }
`;
const AlmeSurveyDialog = (props) => {
    const [surveyInput, setSurveyInput] = useState('');
    const [options] = useState(props.inputMetaData.Body.RadioButtons.radioOptions);
    const managefocus = () => {
        const modalElement = document.getElementById('alme-survey-dialog');
        if (modalElement) {
            const focusableElement = modalElement.querySelectorAll('input');
            const noButtonElement = document.getElementById('alme-survey-dialog-no-button');
            const dailogContentElement = document.getElementById('alme-survey-dailog-content');
            let focusedOptionElement = null;
            const handleTabKeyPress = (event) => {
                if (event.key === "Tab" && !event.shiftKey && (document.activeElement === dailogContentElement)) {
                    event.preventDefault();
                    if (focusedOptionElement) {
                        focusedOptionElement.focus();
                    }
                    else {
                        focusableElement[0].focus();
                        focusedOptionElement = focusableElement[0];
                    }
                }
                if (event.key === "Tab" && event.shiftKey && (document.activeElement === focusedOptionElement)) {
                    event.preventDefault();
                    noButtonElement === null || noButtonElement === void 0 ? void 0 : noButtonElement.focus();
                }
            };
            const handleKeySelected = (element) => {
                focusedOptionElement = element;
            };
            modalElement.addEventListener("keydown", handleTabKeyPress);
            focusableElement.forEach((element) => {
                element.addEventListener("change", function () {
                    handleKeySelected(element);
                });
            });
        }
    };
    useEffect(() => {
        if (!props.isOpen) {
            focusMessageBox();
        }
        else {
            managefocus();
        }
    }, [props.isOpen]);
    const handleSurveySubmit = () => {
        const inputText = surveyInput.trim();
        props.onSubmitSurvey(false, inputText);
    };
    const handleSurveyCancel = () => {
        props.onSubmitSurvey(true);
    };
    const onChange = (option) => {
        const inputText = option;
        setSurveyInput(inputText);
    };
    return (React.createElement(React.Fragment, null, props.isOpen
        ?
            React.createElement(ModalDialog, { id: 'alme-survey-dialog', ariaLabel: "IVA survey dialog", ariaDescribedBy: "alme-survey-dialog-title", style: { backgroundColor: '#e6e6e6' }, header: React.createElement(DialogTitle, { id: 'alme-survey-dialog-title' }, props.inputMetaData.Header.Title), footer: React.createElement(DialogFooter, null,
                    React.createElement(DialogButton, { id: 'alme-survey-dialog-yes-button', buttonType: 'primary', onClick: handleSurveySubmit }, props.inputMetaData.Footer.SubmitLink.DisplayText),
                    React.createElement(DialogButton, { id: 'alme-survey-dialog-no-button', buttonType: 'ghost', onClick: handleSurveyCancel }, props.inputMetaData.Footer.CancelLink.DisplayText)) },
                React.createElement(DialogContent, { id: "alme-survey-dailog-content", tabIndex: 0 },
                    React.createElement(StyledRadioGroup, { className: "radio-group", "aria-labelledby": "alme-survey-dialog-title", onChange: onChange, selected: surveyInput }, options.map((value, index) => (React.createElement(Radio, { id: `survey-dialog-option-${index}`, name: `survey-dialog-option`, key: `survey-dialog-option-${index}`, value: value }, value))))))
        : null));
};
export default AlmeSurveyDialog;
